document.addEventListener('DOMContentLoaded', function(){
  var wrap = document.getElementById('pdp-savings-calculator');
  if (!wrap) return;

  var trigger = wrap.querySelector('.pdp-savings__trigger');
  var panel   = wrap.querySelector('.pdp-savings__panel');
  var inner   = wrap.querySelector('.pdp-savings__panel-inner');
  var range   = wrap.querySelector('.pdp-fan-range');
  var countEl = wrap.querySelector('.pdp-savings__fan-count');
  var fanLbl  = wrap.querySelector('.pdp-savings__fan-label');
  var costs   = wrap.querySelectorAll('.pdp-savings__cost-incurred');
  var maxEl   = wrap.querySelector('.pdp-savings__max-saving');
  var yearCost = wrap.querySelector('.pdp-savings__cost-year');
  var nYearsCost = wrap.querySelector('.pdp-savings__cost-n-years');
  yearCost.textContent = `₹ ${parseInt(yearCost.dataset.value).toLocaleString('en-IN')}`
  nYearsCost.textContent = `₹ ${parseInt(nYearsCost.dataset.value).toLocaleString('en-IN')}`

  /* ── Accordion ─────────────────────────────────────────── */
  function openPanel() {
    panel.style.maxHeight = inner.scrollHeight + 'px';
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('is-open');
    panel.addEventListener('transitionend', function done() {
      panel.style.maxHeight = 'none';
      panel.removeEventListener('transitionend', done);
    });
  }

  function closePanel() {
    panel.style.maxHeight = inner.scrollHeight + 'px';
    requestAnimationFrame(function () { panel.style.maxHeight = '0'; });
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.classList.remove('is-open');
  }

  trigger.addEventListener('click', function () {
    trigger.getAttribute('aria-expanded') === 'true' ? closePanel() : openPanel();
  });

  /* ── Costs ─────────────────────────────────────────────── */
  function popAnimate(el) {
    el.classList.remove('is-animating');
    void el.offsetWidth;
    el.classList.add('is-animating');
  }

  function updateCosts(count) {
    var costVals = [];
    costs.forEach(function (el) {
      var base = parseFloat(el.dataset.cost);
      var calc = Math.round(base * count);
      el.textContent = calc.toLocaleString('en-IN');
      popAnimate(el);
      costVals.push(calc);
    });
    /* Teaser: difference between card 1 and card 2 */
    if (maxEl && costVals.length >= 2) {
      const value = Math.abs(costVals[0] - costVals[1]).toLocaleString('en-IN');
      // maxEl.textContent = value;
      yearCost.textContent = `₹ ${value}`;
      nYearsCost.textContent = `₹ ${(Math.abs(costVals[0] - costVals[1]) * 5).toLocaleString('en-IN')}`;
    }
  }

  range.addEventListener('input', function () {
    var val = parseInt(this.value, 10);
    countEl.textContent = val;
    fanLbl.textContent  = val === 1 ? 'fan' : 'fans';
    updateCosts(val);
  });

  /* Init */
  costs.forEach(function (el) {
    el.textContent = Math.floor(parseFloat(el.dataset.cost)).toLocaleString('en-IN');
  });
})
